import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import InvoiceReport from '../../components/reports/modals/InvoiceReport';
import MedicalHistoryReport from '../../components/reports/modals/MedicalHistoryReport';
import AppointmentReport from '../../components/reports/modals/AppointmentReport';

const ReportsPage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Reports</Typography>
            <List>
              <MedicalHistoryReport />
              <InvoiceReport />
              <AppointmentReport />
            </List>
        </>
    );
};

export default ReportsPage;
